import React from 'react'
import styled from '@emotion/styled'
import { Form, color } from 'stylist'
import { Bold, Slate } from 'components/Text'
import { pickKeysThatStartWith, commaify } from 'utils'
import sumBy from 'lodash/sumBy'

const Red = styled.span`
  color: ${color('red')};
`

const Sum = ({ qualID, quotas, completions }) => {
  const quotasForSelected = pickKeysThatStartWith(quotas, qualID)
  const sum = sumBy(Object.values(quotasForSelected), val => val.limit || 0)
  return sum > completions ? <Red>{commaify(sum)}</Red> : commaify(sum) || '--'
}

const QuotaTotals = ({ qualID }) => (
  <Form.Field
    name="completions"
    render={({ value: completions }) => (
      <Form.Field
        name="quotas"
        render={({ value: quotas }) => (
          <Bold>
            <Sum qualID={qualID} quotas={quotas} completions={completions} />/
            <Slate>{commaify(completions) || '--'} Total</Slate>
          </Bold>
        )}
      />
    )}
  />
)

export default QuotaTotals



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/QuotaTotals.js